<script setup lang="ts">
  import DOMPurify from 'dompurify';

  import type { Task } from '@stuut/api/models';
  import { HoverCardContent } from '@ui/components/hover-card';

  interface Props {
    task: Task;
  }

  defineProps<Props>();
</script>

<template>
  <HoverCardContent side="top" align="end" :side-offset="8" class="w-96 p-0">
    <div class="flex items-center gap-x-2 border-b px-4 py-2.5 text-sm">
      <i class="far fa-envelope-circle-check" />
      <strong class="truncate">{{ task.label }}</strong>
    </div>

    <div
      class="max-h-64 overflow-y-auto p-4 text-xs prose prose-sm"
      v-html="DOMPurify.sanitize(task.responseData?.data?.html_body ?? '')"
    />

    <div v-if="$slots.footer" class="border-t p-3">
      <slot name="footer" />
    </div>
  </HoverCardContent>
</template>
